import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultOutcomePageComponent } from './components/result-outcome-page/result-outcome-page.component';
import { AdminResultOutcomeComponent } from './components/admin-result-outcome/admin-result-outcome.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path:':name',component:ResultOutcomePageComponent, data: { title: '' }
  },
  {
    path:'',canActivate:[AdminGuard], component:AdminResultOutcomeComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResultOutcomeRoutingModule { }
